import _ from 'lodash';
import { ATTRIBUTE_TYPE } from '../../HelperMethods/enums';

import {
  ASSET_LIST_KEY,
  ASSET_LIST_COLUMN_VISIBILITY_KEY,
  ASSET_LIST_TABLE_ORDER_KEY,
  ASSET_LIST_COLUMN_WIDTH_KEY,
} from '../../HelperMethods/AgGridConstants';

export function getGlobalAttributeToColumn(globalAttributes = []) {
  const globalAttributeColumnArr = [];
  for (const attribute of globalAttributes || []) {
    if (attribute.attributeType === ATTRIBUTE_TYPE.INTEGER.key) {
      const columnObj = {
        headerName: attribute.attributeDisplayName,
        field: `customAttributes.${attribute.attributeName}`,
        filter: 'agNumberColumnFilter',
        filterParams: {
          filterOptions: ['equals'],
          debounceMs: 500,
          suppressAndOrCondition: true,
        },
        width: 150,
        valueGetter: (params) => _.get(params, `data.customAttributes.${attribute.attributeName}`),
        hide: true,
      };
      globalAttributeColumnArr.push(columnObj);
    } else if (attribute.attributeType === ATTRIBUTE_TYPE.STRING.key) {
      const columnObj = {
        headerName: attribute.attributeDisplayName,
        field: `customAttributes.${attribute.attributeName}`,
        filter: 'agTextColumnFilter',
        filterParams: {
          filterOptions: ['equals'],
          debounceMs: 500,
        },
        width: 150,
        valueGetter: (params) => {
          return _.get(params, `data.customAttributes.${attribute.attributeName}`);
        },
        hide: true,
      };
      globalAttributeColumnArr.push(columnObj);
    }
  }
  return globalAttributeColumnArr;
}

export function mergeAssetWithAreas(response, areaList = []) {
  const { assets } = response;
  const areasDict = _.keyBy(areaList, 'id');
  for (const asset of assets) {
    const { areas = [] } = asset;
    if (areas && areas.length) {
      const updatedAreas = areas
        .map((area) => {
          const reqArea = areasDict[area.areaId];
          if (reqArea) {
            return { ...area, areaName: reqArea.name };
          }
          return null;
        })
        .filter((area) => area && !area.isDeleted);
      asset.areas = updatedAreas;
    }
  }
  return response;
}

export function userListtoUserPicklist(users) {
  const obj = {};
  obj.key = users.id;
  obj.value = users.id;
  obj.text = `${users?.firstName || ''} ${users?.lastName || ''}`;
  return obj;
}

export function mapErrorToPreferredLocationFormField({ formValues }) {
  const error = [];
  const preferredLocation = _.get(formValues, 'preferred_location', []);
  preferredLocation.forEach((prefLoc, index) => {
    const errObj = {};
    if (prefLoc.locationType && !prefLoc.location) {
      errObj.location = 'Location is not selected';
    }
    if (!prefLoc.locationType && prefLoc.location) {
      errObj.locationType = 'Location Type is not Selected';
    }
    if (Object.keys(errObj).length !== 0) {
      error[index] = errObj;
    }
  });
  return { isValid: error.length === 0, error };
}

export function columnsAsPerConfig(columns, userConfig) {
  const assetConfig = userConfig?.[ASSET_LIST_KEY] ?? {};
  let columnOrder = JSON.parse(assetConfig?.[ASSET_LIST_TABLE_ORDER_KEY] ?? '[]');
  const columnVisibility = JSON.parse(assetConfig?.[ASSET_LIST_COLUMN_VISIBILITY_KEY] ?? '{}');
  const columnWidth = JSON.parse(assetConfig?.[ASSET_LIST_COLUMN_WIDTH_KEY] ?? '{}');

  console.log('columnOrder,columnVisibility', { columnVisibility, columnOrder, columnWidth });
  if (Object.keys(columnVisibility)?.length === 0) {
    return columns;
  }
  const clonedColumnsMap = _.keyBy(columns, 'field');
  if (columnOrder.length === 0) {
    columnOrder = columns.map((col) => col.field);
  }
  Object.keys(clonedColumnsMap).forEach((key) => {
    if (!_.isNil(columnVisibility) && !_.isNil(columnVisibility[key])) {
      clonedColumnsMap[key].hide = !columnVisibility[key];
    }
  });
  for (const [field, column] of Object.entries(clonedColumnsMap)) {
    if (columnWidth[field]) {
      Object.assign(column, { width: columnWidth[field] });
    }
  }
  const columnDefs = columnOrder.map((columnKey) => clonedColumnsMap[columnKey]).filter((col) => !!col);
  return columnDefs;
}
